import React from 'react';

export interface PanelIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const PanelIcon: React.FC<PanelIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.751 3.125H3.46v4.292h7.292zm11.459 0h-7.292v10.292h7.291zm0 14.458h-7.292v4.292h7.291zm-11.459-6H3.46v10.292h7.292z"/>
    </svg>
  );
};

export default PanelIcon;
